export default function CoralGablesHeroSection() {
  return (
    <section className="relative bg-[#1A365D] overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Coral%20Gables%20Florida%20at%20sunset%20showcasing%20Mediterranean%20Revival%20architecture%20red%20tile%20rooftops%20tree-lined%20streets%20and%20the%20Biltmore%20Hotel%20dome%20in%20the%20distance%20warm%20golden%20hour%20lighting%20lush%20tropical%20landscaping%20elegant%20suburban%20atmosphere%20high%20quality%20architectural%20photography&width=1400&height=600&seq=cg-hero-01&orientation=landscape"
          alt="Coral Gables Mediterranean architecture"
          className="w-full h-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A365D]/70 via-[#1A365D]/50 to-[#1A365D]/90"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 pt-32 pb-20 md:pt-40 md:pb-28">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-[#F6C344] text-[#1A365D] font-bold text-xs uppercase tracking-wider px-4 py-2 rounded-full mb-6">
            <i className="ri-flashlight-line"></i>
            Emergency &amp; Expedited Passports
          </div>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Emergency Passport Services in <span className="text-[#F6C344]">Coral Gables, FL</span>
          </h1>
          <p className="text-white/80 text-lg md:text-xl leading-relaxed mb-8 max-w-2xl">
            Fast, reliable expedited passport processing for Coral Gables travelers. Whether you are flying out of MIA for a business trip to Latin America, departing on a cruise from the Port of Miami, or sending a UM student abroad — we deliver your passport in as little as 24 hours.
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-4 mb-10">
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
            >
              Start My Passport <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="tel:8772530084"
              className="inline-flex items-center gap-2 text-white/80 hover:text-[#F6C344] font-semibold text-base transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line"></i> 877-253-0084
            </a>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { icon: "ri-time-line", label: "As fast as 24 hours" },
              { icon: "ri-shield-check-line", label: "A+ BBB Rated" },
              { icon: "ri-government-line", label: "Registered Courier" },
              { icon: "ri-customer-service-2-line", label: "Real Human Support" },
            ].map((b, i) => (
              <div key={i} className="flex items-center gap-2.5 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-3">
                <i className={`${b.icon} text-[#F6C344] text-lg`}></i>
                <span className="text-white text-xs font-semibold">{b.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}